import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PiChatToolRow, type ToolItem } from 'ts-components/PiChat/PiChatLog';
import { resolveCaptureUrl } from 'ts-components/PiChat/uploadUrl';
import { CaptureThumb, ToolWithCapture } from './styles';

interface CaptureImage {
  url: string;
  width: number;
  height: number;
}

const CaptureThumbnail: FC<{ image: CaptureImage }> = ({ image }) => {
  const { t } = useTranslation();
  const [failed, setFailed] = useState(false);
  if (failed) return null;
  return (
    <CaptureThumb
      href={image.url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t('Open the block screenshot in a new tab')}
      data-qa-id="ai-block-panel-capture-image"
    >
      <img
        src={image.url}
        alt=""
        width={image.width}
        height={image.height}
        loading="lazy"
        onError={() => setFailed(true)}
      />
    </CaptureThumb>
  );
};

const rowCaptureImage = (
  item: ToolItem,
  wsUrl: string
): CaptureImage | undefined => {
  if (item.status !== 'ok' || !item.capture) return undefined;
  const url = resolveCaptureUrl(item.capture.path, wsUrl);
  return url
    ? { url, width: item.capture.width, height: item.capture.height }
    : undefined;
};

export const CaptureToolRow: FC<{
  item: ToolItem;
  wsUrl: string;
}> = ({ item, wsUrl }) => {
  const image = rowCaptureImage(item, wsUrl);
  return image ? (
    <ToolWithCapture>
      <PiChatToolRow item={item} />
      <CaptureThumbnail key={image.url} image={image} />
    </ToolWithCapture>
  ) : (
    <PiChatToolRow item={item} />
  );
};
